import { ErrorSource, errorSourceLabels, sagaEventLabels, type ErrorHandlingSagaPagedQuery } from '@/dtos/ErrorHandlingSaga'
import { useErrorsFilterContext } from '@/pages/ErrorsPage'
import { Box, Button, FormControl, FormLabel, Grid, Input, Select } from '@chakra-ui/react'
import { Insurer } from 'BrokerTsLib/src/enums'
import { useState } from 'react'

const states = ['ON_HOLD', 'PENDING_RETRY', 'QUEUED', 'RESOLVED', 'DISCARDED', 'CANCELED']
const processingTypes = ['RETRYABLE', 'MANUAL']

export const ErrorSearchForm = () => {
  const { filter, updateFilter } = useErrorsFilterContext()
  const [query, setQuery] = useState<ErrorHandlingSagaPagedQuery>(filter)

  // Keep local form in sync when the preset tabs change the filter from outside.
  if (query.preset !== filter.preset) {
    setQuery(filter)
  }

  const setText = (key: keyof ErrorHandlingSagaPagedQuery) => (e: any) => {
    const value = e.target.value
    setQuery(prev => ({ ...prev, [key]: value !== '' ? value : undefined }))
  }

  const setNumber = (key: keyof ErrorHandlingSagaPagedQuery) => (e: any) => {
    const value = e.target.value
    setQuery(prev => ({ ...prev, [key]: value !== '' ? Number(value) : undefined }))
  }

  const search = () => updateFilter({ ...query, pageIndex: 1 })

  return (
    <Box p={4}>
      <Grid templateColumns={{ base: 'repeat(1, 1fr)', xl: 'repeat(6, 1fr)' }} gap={4}>
        <FormControl>
          <FormLabel>Typ požadavku</FormLabel>
          <Select placeholder="-- vše --" value={query.eventType ?? ''} onChange={setNumber('eventType')}>
            {Object.entries(sagaEventLabels).map(([value, label]) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Typ zpracování</FormLabel>
          <Select placeholder="-- vše --" value={query.processingType ?? ''} onChange={setText('processingType')}>
            {processingTypes.map(t => <option key={t} value={t}>{t}</option>)}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Stav</FormLabel>
          <Select placeholder="-- dle filtru --" value={query.state ?? ''} onChange={setText('state')}>
            {states.map(s => <option key={s} value={s}>{s}</option>)}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Pojišťovna</FormLabel>
          <Select placeholder="-- vše --" value={query.insurerId ?? ''} onChange={setNumber('insurerId')}>
            {Object.entries(Insurer)
              .filter(([, value]) => typeof value === 'number')
              .map(([key, value]) => (
                <option key={value} value={value as number}>{key}</option>
              ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Zdroj chyby</FormLabel>
          <Select placeholder="-- vše --" value={query.errorSource ?? ''} onChange={setNumber('errorSource')}>
            <option value={ErrorSource.INTERNAL}>{errorSourceLabels[ErrorSource.INTERNAL]}</option>
            <option value={ErrorSource.INSURER}>{errorSourceLabels[ErrorSource.INSURER]}</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Číslo PS</FormLabel>
          <Input value={query.contractNumber ?? ''} onChange={setText('contractNumber')} />
        </FormControl>

        <FormControl>
          <FormLabel>Číslo LS</FormLabel>
          <Input value={query.leasingContractNumber ?? ''} onChange={setText('leasingContractNumber')} />
        </FormControl>

        <FormControl>
          <FormLabel>Vytvořeno od</FormLabel>
          <Input type="datetime-local" value={query.createdFrom ?? ''} onChange={setText('createdFrom')} />
        </FormControl>

        <FormControl>
          <FormLabel>Vytvořeno do</FormLabel>
          <Input type="datetime-local" value={query.createdTo ?? ''} onChange={setText('createdTo')} />
        </FormControl>

        <Box alignSelf="flex-end">
          <Button colorScheme="blue" onClick={search} w="100%">Filtrovat</Button>
        </Box>
      </Grid>
    </Box>
  )
}
